<div class="container-fluid">
  <div class="card">
    <div class="card-header">
      <h5>Offers Management</h5>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="filterByStatusValue" (change)="changeFilterOffer(filterByStatusValue)">
            <option value="2">Active Offers</option>
            <option value="1">Expired Offers</option>
            <option value="3">Upcoming Offers</option>
          </select>
        </div>
        <div class="col-md-9 text-end">
          <button class="btn btn-primary" (click)="showOfferTemplateList()">
            <i class="fa fa-plus-circle me-1"></i> New Offer
          </button>
        </div>
      </div>
      
      <div *ngIf="triggerOffersInfoMsg" class="alert alert-success mb-3">
        {{triggerOffersInfoMsg}}
      </div>
      
      <div *ngIf="!offers || offers.length === 0" class="text-center p-5">
        <p>No offers available. Create a new offer to get started.</p>
      </div>
      
      <div class="row" *ngIf="offers && offers.length > 0">
        <div class="col-md-4 mb-4" *ngFor="let offer of offers; let i = index">
          <div class="card h-100">
            <div class="card-img-top position-relative" style="height: 160px; background-color: #f8f9fa;">
              <img *ngIf="offer.public_img_url" [src]="offer.public_img_url" alt="Offer" class="w-100 h-100" style="object-fit: cover;">
              <img *ngIf="!offer.public_img_url && !offer.video_url" src="assets/images/no-image.jpg" alt="No Image" class="w-100 h-100" style="object-fit: cover;">
              
              <div class="position-absolute top-0 end-0 p-2 d-flex gap-1">
                <button class="btn btn-sm btn-light" (click)="removeOffer(offer._id, i, $event)">
                  <i class="fa fa-trash"></i>
                </button>
                <button *ngIf="!offer.is_default" class="btn btn-sm btn-light" (click)="setDefaultCampaign(offer._id, offer.shop_id_list, i)">
                  <i class="fa fa-star-o"></i>
                </button>
                <button *ngIf="offer.is_default" class="btn btn-sm btn-light text-warning">
                  <i class="fa fa-star"></i>
                </button>
              </div>
            </div>
            
            <div class="card-body">
              <h5 class="card-title">{{offer.headline}}</h5>
              <p class="card-text">{{offer.sub_title}}</p>
              
              <div *ngIf="offer.cta?.action_type === 'get_code'" class="small text-muted">
                <div>Assigned Codes: {{offer.total_count === 0 ? 'NA' : offer.used_codes}}</div>
                <div>Unassigned Codes: {{offer.total_count === 0 ? 'NA' : offer.unused_codes}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="text-center mt-3" *ngIf="offers && offers.length >= 12">
        <button class="btn btn-outline-secondary" [disabled]="pagerBusy" (click)="nextPage()">
          Load More
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  /* Modern styling */
  :host {
    display: block;
    padding: 20px;
  }
  
  /* Offers Config Card */
  .offers-config-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
  }
  
  /* Card Header */
  .card-header {
    padding: 16px 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #f0f0f0;
  }
  
  /* Card Body */
  .card-body {
    padding: 20px;
  }
  
  /* Filters Container */
  .filters-container {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }
  
  /* Offer Card */
  .offer-card {
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    position: relative;
    background: white;
  }
  
  .offer-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  /* Offer Actions */
  .offer-actions {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
    display: flex;
    gap: 4px;
  }
  
  .action-btn {
    width: 28px;
    height: 28px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    color: #6c757d;
    transition: all 0.2s ease;
  }
  
  .action-btn:hover {
    background: white;
    color: #0d6efd;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }
  
  .action-btn.active {
    color: #0d6efd;
  }
  
  /* Offer Media */
  .offer-media {
    height: 160px;
    overflow: hidden;
    background-color: #f8f9fa;
  }
  
  .offer-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  /* Offer Details */
  .offer-details {
    padding: 16px;
  }
  
  .offer-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #212529;
  }
  
  .offer-subtitle {
    font-size: 14px;
    color: #6c757d;
    margin-bottom: 8px;
  }
  
  .coupon-details {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
    font-size: 13px;
    color: #6c757d;
  }
  
  /* Empty State */
  .empty-state {
    border: 1px dashed #dee2e6;
    border-radius: 8px;
    margin: 20px 0;
  }
  
  /* Notes */
  .notes {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    font-size: 0.875rem;
  }
</style>
